/**
 * @fileoverview 共通コレクション collection
 *
 */
'use strict';
// Library Import
import _ from 'lodash';
import Backbone from 'backbone';
import 'backbone-validation';
// Util Import
import * as ConstUtil from '../util/ConstUtil';
import * as LogUtil from '../util/LogUtil';
import ConnectionUtil from '../util/ConnectionUtil';

/**
 * 共通Collection
 *
 * @class CommonCollection
 * @extends {Backbone.Collection}
 */
class CommonCollection extends Backbone.Collection {
  constructor() {
    super();
    // Backbone ValidationをCollectionに取り込む
    _.extend(Backbone.Collection.prototype, Backbone.Validation.mixin);
    // Backbone Validationのpatternを拡張(空文字対策)
    _.extend(Backbone.Validation.validators, {
      extendPattern: function(value, attr, customValue, model) {
        if (value !== '') {
          return Backbone.Validation.validators.pattern(
            value,
            attr,
            customValue,
            model
          );
        }
      },
      // Backbone Validation 一致しないパターン
      notEqual: function(value, attr, customValue, model) {
        if (value !== customValue) {
          return 'not match ' + customValue;
        }
      }
    });
  }

  /**
   * 拡張preValidate
   *
   * @memberof CommonCollection
   * @param {Object} validationRule validationルール
   * @param {Object} data validationデータ
   * @return {string} エラー文字列
   */
  extendPreValidate(validationRule, data) {
    // validationルールをセット
    this.validation = validationRule;
    // validation対象
    let validationTarget = {};
    // チェック対象からvalidation対象を作成する
    for (let key of _.keys(this.validation)) {
      validationTarget[key] = '';
    }
    // validation対象にdataをマージする
    validationTarget = _.extend(validationTarget, data);
    // validationを行い結果を返す
    return this.preValidate(validationTarget);
  }

  /**
   * リストの型チェック
   *
   * @param {Array} list
   * @returns エラー
   * @memberof CommonCollection
   */
  checkListType(list) {
    if (!_.isArray(list)) {
      return 'Validation Error';
    }
  }

  /**
   *  ファイルアップロード情報取得
   *
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @param {String} api API
   * @memberof CommonCollection
   */
  getFileUpload(callback, payload, api) {
    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: payload
    };
    ConnectionUtil.callAPI(
      api,
      request,
      ConstUtil.Common.TIMEOUT.DEFAULT,
      function(err, res) {
        if (err) {
          callback.failure(err);
          return;
        }
        callback.success(res.data);
        return;
      }
    );
  }

  /**
   * ファイルアップロード
   *
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof CommonCollection
   */
  fileUpload(callback, payload) {
    this.fileUploadCallback = callback;
    let request = {
      data: payload.file
    };
    LogUtil.d(payload.file.name);
    let axiosConfig = {
      headers: {
        'x-ms-blob-type': 'BlockBlob'
      },
      timeout: ConstUtil.Common.TIMEOUT.DEFAULT
    };
    ConnectionUtil.upload(payload.url, request, axiosConfig, function(
      err,
      res
    ) {
      if (err) {
        LogUtil.d(err);
        callback.failure(err);
        return;
      }
      callback.success(res);
      return;
    });
  }

  /**
   * ファイルダウンロード
   *
   * @param {Object} callback  コールバック
   * @param {Object} fileInfo ファイル情報
   * @memberof CommonCollection
   */
  fileDownload(callback, fileInfo) {
    let axiosConfig = {
      headers: {
        [ConstUtil.Common.REQUEST_HEADER_KEYS
          .X_LOGIPULL_TOKEN]: localStorage.getItem(
          ConstUtil.Common.STORAGE_KEY.TOKEN
        )
      },
      timeout: ConstUtil.Common.TIMEOUT.DEFAULT,
      responseType: 'arraybuffer'
    };
    ConnectionUtil.download(fileInfo.url, axiosConfig, function(err, res) {
      if (err) {
        LogUtil.d(err);
        callback.failure(err);
        return;
      }
      callback.success(new Blob([res.data]), fileInfo);
      return;
    });
  }
}
export default CommonCollection;



// WEBPACK FOOTER //
// ./src/js/collection/CommonCollection.jsx